import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedCarousel from '@/pages/home/components/FeaturedCarousel';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import HotSites from '@/pages/home/components/HotSites';
import NewSites from '@/pages/home/components/NewSites';
import HomeSidebar from '@/pages/home/components/HomeSidebar';
import AboutIntro from '@/pages/home/components/AboutIntro';

export default function Home() {
  return (
    <div className="w-full animate-fade-in">
      <HeroSection />
      <FeaturedCarousel />

      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_320px]">
          <div className="flex flex-col gap-10">
            <CategoryGrid />
            <HotSites />
            <NewSites />
          </div>
          <HomeSidebar />
        </div>
      </div>

      <AboutIntro />
    </div>
  );
}